import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

type ValidateAudioLanguageRowProps = {
  t: Record<string, unknown>;
  selectedLanguage: string;
  confirmedLanguage: string;
  showLanguageConfirmation: boolean;
  languages: Array<{ code: string; name: string; displayName: string }>;
  onToggleLanguageConfirmation: () => void;
  onConfirmedLanguageChange: (value: string) => void;
};

/** "Langue détectée" with its correction picker, unchanged in behaviour. */
export function ValidateAudioLanguageRow({
  t,
  selectedLanguage,
  confirmedLanguage,
  showLanguageConfirmation,
  languages,
  onToggleLanguageConfirmation,
  onConfirmedLanguageChange,
}: ValidateAudioLanguageRowProps) {
  return (
    <div className="space-y-2">
      <div className="flex min-h-11 items-center justify-between gap-3 text-sm">
        <span className="flex items-center gap-2 text-muted-foreground">
          {String(t.detectedLanguage ?? '')}
          <span className="rounded-md border border-border/60 px-2 py-0.5 text-xs font-medium text-foreground">{selectedLanguage}</span>
        </span>
        <button
          type="button"
          onClick={onToggleLanguageConfirmation}
          className="inline-flex h-11 items-center px-2 text-sm font-medium text-brand hover:underline"
        >
          {showLanguageConfirmation ? String(t.cancel ?? '') : String(t.correct ?? '')}
        </button>
      </div>
      {showLanguageConfirmation && (
        <div className="space-y-2 rounded-lg border border-border/60 bg-surface-2 p-3">
          <label className="text-xs font-medium text-muted-foreground">{String(t.correctLanguagePrompt ?? '')}</label>
          <Select value={confirmedLanguage || selectedLanguage} onValueChange={onConfirmedLanguageChange}>
            <SelectTrigger className="h-11 bg-surface">
              <SelectValue placeholder={String(t.selectActualLanguage ?? '')} />
            </SelectTrigger>
            <SelectContent>
              {languages.map((lang) => (
                <SelectItem key={lang.code} value={lang.code}>
                  {lang.displayName}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
